import {useContactsUpdater} from "./contacts-updater";
import {useProfileInfoUpdater} from "./profile-info-updater";
import {ContactChangeStatus} from "../index";

export const useProfileUpdater = (profile) => {
    const [profileUpdater, isProfileChanged] = useProfileInfoUpdater(profile)
    const [contactsUpdater, isContactsChanged] = useContactsUpdater(profile?.contacts)

    const isChanged = isProfileChanged || isContactsChanged

    const buildFormData = () => {
        const buildImageFormData = () => {
            const imageFormData = new FormData()

            if (profileUpdater.profileImage != null) {
                imageFormData.append("profileImage", profileUpdater.profileImage)
            }

            if (profileUpdater.backgroundImage != null) {
                imageFormData.append("backgroundImage", profileUpdater.backgroundImage)
            }

            return imageFormData
        }

        const buildProfileFormData = () => {
            const contacts = contactsUpdater.getContacts(null, true)
                .filter((contact) => contact.status !== ContactChangeStatus.NONE)

            return {
                name: profileUpdater.name,
                job: profileUpdater.job,
                role: profileUpdater.role,
                residence: profileUpdater.residence,
                description: profileUpdater.description,
                contacts: contacts,
                profileLink: profileUpdater.profileLink
            }
        }

        return [buildProfileFormData(), buildImageFormData()]
    }

    return [profileUpdater, contactsUpdater, isChanged, buildFormData]
}